import React, { useState } from 'react';
import { Button, Menu, MenuItem } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useTranslation } from 'services/localization';

interface Props {
	triggerImport: () => void;
	triggerExport: () => void;
}

const MoreActionButton = (props: Props) => {
	const { t } = useTranslation();
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const open = !!anchorEl;

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleImportClick = () => {
		handleClose();
		props.triggerImport();
	};

	const handleExportClick = () => {
		handleClose();
		props.triggerExport();
	};

	return (
		<>
			<Button onClick={handleClick} endIcon={<ArrowDropDownIcon />} sx={{ minWidth: 0 }}>
				{t('common:more')}
			</Button>
			<Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
				<MenuItem onClick={handleImportClick}>{t('inventory.moreActionImport', 'Import')}</MenuItem>
				<MenuItem onClick={handleExportClick}>{t('dataGrid.toolbarExport', 'Export')}</MenuItem>
			</Menu>
		</>
	);
};

export default MoreActionButton;
